import { useEffect } from "react";
import debounce from "lodash/debounce";

export const useAddressInputTrigger = ({ enabled, timeout, triggerChat }) => {
  useEffect(() => {
    if (!enabled) return;

    const debouncedTrigger = debounce(() => {
      triggerChat("Address Entry");
    }, timeout * 1000);

    const listener = (event) => {
      if (event?.detail?.resetOnly) {
        debouncedTrigger.cancel();
        return;
      }

      if (event?.detail?.suggestions === false) {
        debouncedTrigger.cancel();
        return;
      }

      debouncedTrigger();
    };

    document.addEventListener("address-input", listener);

    return () => {
      document.removeEventListener("address-input", listener);
      debouncedTrigger.cancel();
    };
  }, [enabled, timeout, triggerChat]);
};
